import Util from '../util';
import { Toast } from 'antd-mobile/lib';


//获取用户风险等级
export const getRiskType = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content, params.raiseMethod);
					console.log(succ.content, params.raiseMethod);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/account/queryRankName', params, successCallback, errorCallback);
		// Util.get('http://127.0.0.1:3001' + '/api/account/queryRankName', params, successCallback, errorCallback);
	}
}

//获取用户风险等级问卷编号
export const getQuestionnaireNo = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		const successCallback = (succ)=>{
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content, params.raiseMethod);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/account/getQuestionnaireNo', params, successCallback, errorCallback);
	}
}

// 获取问卷列表
export const getQuestionnaireList = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		Toast.hide();
		const successCallback = (succ)=>{
			console.log(succ, 'QuestionnaireListQuestionnaireList');
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					// succallback(succ1.content);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				console.log(err);
				errcallback(Util.errorTxt);
		};
		console.log(params)
		Util.get(Util.url + '/api/account/getQuestion', params, successCallback, errorCallback);
	}
}

// 提交问卷答案
export const saveRiskResult = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
    	Toast.loading('', 0, () => {});
		const successCallback = (succ)=>{
			Toast.hide()
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
			Toast.hide()
			console.log(err);
			errcallback(Util.errorTxt);
		};
		params.clientType='hxcfH5'
		params.answers = JSON.parse(params.answers)
		Util.postNew(Util.url + '/api/v1/account/saveRiskResult?token='+params.token, params, successCallback, errorCallback);
	}
}
/*算风并评估相关定投协议风险是否匹配 */
export const previewPlanRisk = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		Toast.loading('', 0, () => {});
		const successCallback = (succ)=>{
			Toast.hide()
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				Toast.hide()
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/account/previewPlanRisk', params, successCallback, errorCallback);
	}
}
 /* 终止风险异常定投协议 */
export const stopPlanByRiskResult = (params, succallback, errcallback)=>{
	return (dispatch, getState)=>{
		Toast.loading('', 0, () => {});
		const successCallback = (succ)=>{
			Toast.hide()
			console.log(succ);
			if(succ && succ.code === '0000'){
					succallback(succ.content);
			}else{
				console.log('后台返回数据有误！' + succ.message);
					errcallback(succ.message);
			}
		};
		const errorCallback = (err)=>{
				Toast.hide()
				console.log(err);
				errcallback(Util.errorTxt);
		};
		Util.get(Util.url + '/api/account/stopPlanByRiskResult', params, successCallback, errorCallback);
	}
}




// WEBPACK FOOTER //
// ./src/action/questionnairesAction.js